import { ReactNode } from 'react';

import { ActionBar } from '@dreryk/react-components';

type NfzSettingsActionBarProps = {
   readonly children: ReactNode;
};

export const NfzSettingsActionBar = (props: NfzSettingsActionBarProps): JSX.Element => {
   return (
      <ActionBar id='nfz-settings-action-bar' testId='nfzSettings'>
         {props.children}
      </ActionBar>
   );
};
